// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"559":"4ea2ac8a","890":"44c02d35"}[chunkId] + ".chunk.js";
};